import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { mediaUrl } from "../lib/api";
import api from "../lib/api";

export default function Authentication() {
  const [hc, setHc] = useState({});
  useEffect(() => { api.get("/content/homepage").then((r) => setHc(r.data.data || {})).catch(() => {}); }, []);
  return (
    <div className="luxy-container py-16 sm:py-24">
      <div className="max-w-3xl mx-auto text-center mb-16">
        <p className="eyebrow mb-3">Trust & Provenance</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-pitch tracking-tight">{hc.authentication_heading || "The LUXYREIGN Standard"}</h1>
        <p className="text-charcoal/80 leading-relaxed mt-6 text-lg font-light">{hc.authentication_text}</p>
      </div>
      {hc.authentication_image && (
        <div className="aspect-[16/9] bg-bone overflow-hidden mb-16 max-w-4xl mx-auto">
          <img src={mediaUrl(hc.authentication_image)} alt="Authentication process" className="w-full h-full object-cover" />
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 max-w-5xl mx-auto">
        {(hc.standard_points || []).map((s, i) => (
          <div key={i}>
            <div className="font-mono text-champagne-dark text-sm mb-3">0{i + 1}</div>
            <h3 className="font-serif text-2xl text-pitch mb-2">{s.title}</h3>
            <p className="text-sm text-charcoal/70 leading-relaxed">{s.text}</p>
          </div>
        ))}
      </div>
      <div className="text-center mt-16 text-sm text-stonemuted max-w-2xl mx-auto">
        <p>LUXYREIGN displays authentication information only where it has been verified for a specific item. We never fabricate certificates, serial numbers, provenance or guarantees. This wording is configurable by the administrator.</p>
        <Link to="/legal/authentication_policy" className="inline-block mt-6 text-xs font-mono uppercase tracking-[0.2em] border-b border-pitch pb-1 text-pitch">Authentication Policy</Link>
      </div>
    </div>
  );
}
